import {PLACEHOLDER_IMAGE} from "../../../../constants/cdn-assets";
import * as _ from "lodash";

export default {
    computed: {
        imageUrl() {
            return this.product.image || PLACEHOLDER_IMAGE;
        },
        maxProductsCount() {
            return _.get(this.campaign, 'compensation_settings.max_products', 0);
        },
        selectedProductsCount() {
            return this.products.filter(product => !!product).length;
        },
        maxProductsString() {
            return (this.maxProductsCount && this.maxProductsCount !== 0) ? `/ ${this.maxProductsCount}` : '';
        },
        selectedProductsString() {
            return `${this.selectedProductsCount} ${this.maxProductsString} Selected`;
        },
        selectProducts() {
            return _.get(this.campaign, 'compensation_settings.select_products', false);
        },
        productInfo() {
            const selectedVariant = this.product.variant;

            if (selectedVariant) {
                const infoParts = [];

                for (let option of selectedVariant.options) {
                    const optionValue = selectedVariant.option_values.find(value => value.option_id === option.id);
                    if (optionValue !== undefined) {
                        infoParts.push(`${option.name}: ${optionValue.name}`);
                    }
                }

                return infoParts.join(', ');
            }

            return '';
        },
    }
}
